import {
  useQuery,
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseQueryResult
} from 'react-query'
import {
  fetchTwoFaStatus,
  associateSoftwareToken,
  verifySoftwareToken,
  enableTwoFa,
  disableTwoFa,
  TwoFaStatus,
  TwoFaAssociation
} from 'api/twofa'

export function useTwoFaStatus(): UseQueryResult<TwoFaStatus> {
  return useQuery(['twofa-status'], fetchTwoFaStatus, { staleTime: 60_000 })
}

export function useMutateAssociateSoftwareToken(): UseMutationResult<
  TwoFaAssociation,
  unknown,
  void
> {
  return useMutation(associateSoftwareToken)
}

export function useMutateVerifySoftwareToken(): UseMutationResult<
  { success: boolean },
  unknown,
  string
> {
  const qc = useQueryClient()
  return useMutation(verifySoftwareToken, {
    onSuccess: () => {
      qc.invalidateQueries(['twofa-status'])
    }
  })
}

export function useMutateEnableTwoFa(): UseMutationResult<
  { backupCodes: string[] },
  unknown,
  void
> {
  const qc = useQueryClient()
  return useMutation(enableTwoFa, {
    onSuccess: () => {
      qc.invalidateQueries(['twofa-status'])
    }
  })
}

export function useMutateDisableTwoFa(): UseMutationResult<
  void,
  unknown,
  void
> {
  const qc = useQueryClient()
  return useMutation(disableTwoFa, {
    onSuccess: () => {
      qc.invalidateQueries(['twofa-status'])
    }
  })
}
